import {Axios} from '../axios/axios'
//区域列表
export const getZoneList = (e) => {
  return Axios({
    url:"/adminapi/getZoneList",
    method:'POST',
    data:e
  })
}
//获取省份信息 adminapi/getProvinceList
export const getProvinceList = (e) => {
  return Axios({
    url:"/adminapi/getProvinceList",
    method:'POST',
    data:e
  })
}
//adminapi/getMAList 都会区列表
export const getMAList = (e) => {
  return Axios({
    url:"/adminapi/getMAList",
    method:'POST',
    data:e
  })
}
//adminapi/deleteMA 删除都会区
export const deleteMA = (e) => {
  return Axios({
    url:"/adminapi/deleteMA",
    method:'POST',
    data:e
  })
}
//删除区域 adminapi/deleteZone
export const deleteZone = (e) => {
  return Axios({
    url:"/adminapi/deleteZone",
    method:'POST',
    data:e
  })
}
// adminapi/getAvailableZoneNumbers 获取可用的区域编号列表
export const getAvailableZoneNumbers = (e) => {
  return Axios({
    url:"/adminapi/getAvailableZoneNumbers",
    method:'POST',
    data:e
  })
}
//adminapi/getMADropdownList 获取都会区下拉列表
export const getMADropdownList = (e) => {
  return Axios({
    url:"/adminapi/getMADropdownList",
    method:'POST',
    data:e
  })
}
//adminapi/updateZoneStatus 更新区域状态
export const updateZoneStatus = (e) => {
  return Axios({
    url:"/adminapi/updateZoneStatus",
    method:'POST',
    data:e
  })
}
//启用/停用都会区 adminapi/toggleMAStatus
export const toggleMAStatus = (e) => {
  return Axios({
    url:"/adminapi/toggleMAStatus",
    method:'POST',
    data:e
  })
}
//创建区域 adminapi/createZone
export const createZone = (e) => {
  return Axios({
    url:"/adminapi/createZone",
    method:'POST',
    data:e
  })
}
//编辑区域 adminapi/editZone
export const editZone = (e) => {
  return Axios({
    url:"/adminapi/editZone",
    method:'POST',
    data:e
  })
}
//创建都会区 adminapi/createMA
export const createMA = (e) => {
  return Axios({
    url:"/adminapi/createMA",
    method:'POST',
    data:e
  })
}
//编辑都会区 adminapi/editMA
export const editMA = (e) => {
  return Axios({
    url:"/adminapi/editMA",
    method:'POST',
    data:e
  })
}
//转移邮箱 adminapi/transferPostalCodes
export const transferPostalCodes = (e) => {
  return Axios({
    url:"/adminapi/transferPostalCodes",
    method:'POST',
    data:e
  })
}
